<div class="textArea">
  <label>
    <span *ngIf="Required" class="required-asterisk">*</span>
    <span>{{ label }}</span>
  </label>
  <div [class]="isContactPage?'contact-custome-styles':'text-content'">
    <textarea
    (blur)="blur()"
      (input)="change()"
      [disabled]="isDisabled"
      preventSpace
      [(ngModel)]="value"
      [placeholder]="placeholder"
      (paste)="preventPasteMobile($event)"
      (beforeinput)="preventPasteMobile($event)"
    ></textarea>
  </div>
  <div class="error" *ngIf="ShowError">
    <validations [control]="control"></validations>
  </div>
</div>
<!-- [ngClass]="{ valid: control?.valid }" -->
